import React, { useEffect, useMemo, useState } from 'react';
import useFeatureFlags from '@src/hooks/useFeatureFlags';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import { Table } from '@mui/material';
import { useSelector } from 'react-redux';
import {
  StyledFooterLoading,
  StyledTable,
  StyledTableScrollbar,
} from './index.style';
import CustomTableBody from './TableBody';
import CustomTableFooter from './TableFooter';
import TableFooterNew from './TableFooterNew';
import NoData from '../NoData';
import TableBodyNew from './TableBodyNew';

const CustomTable = ({
  useInfiniteScrollRequests,
  flickerBackground,
  columns,
  onChangeRowPage,
  rowsPerPage,
  isScrolling,
  requestListHeight,
  isExpand,
  useNewRequestUI,
  data,
  total,
  page,
  dropTable,
  cellWidth,
  selected = [],
  loading,
  setNumSelected,
  headerPadding,
  footerPadding,
  showNumber,
  onChangePage,
  onSelect,
  onRowClick,
  minWidth,
  tableHeight,
  isStickyHeader = false,
  isShowCheckbox = true,
  limit,
  // isNewHomepage,
}) => {
  const [showScrollbar, setShowScrollbar] = useState(false);
  const isSelected = (row) =>
    selected.filter((item) => item.id === row.id).length > 0;
  const user = useSelector((state) => state.auth.user);
  const { getFeatureValue } = useFeatureFlags();
  const useNewPagination = getFeatureValue(FEATURE_KEYS.NEW_PAGINATION, {
    userId: user.id,
    email: user.email,
    phoneNumber: user.phoneNumber,
  });

  const handleSelectRow = (row) => (event) => {
    const {
      id,
      title,
      audioLink,
      status,
      retentionPeriod,
      createdAt,
      latestRequestId,
    } = row;

    const isSelectedRow = selected.filter((item) => item.id === id).length > 0;

    if (event.target.checked && !isSelectedRow) {
      if (onSelect)
        onSelect([
          ...selected,
          {
            id,
            title,
            audioLink,
            status,
            retentionPeriod,
            createdAt,
            latestRequestId,
          },
        ]);
      setNumSelected((prev) => prev + 1);
      return;
    }

    if (onSelect) {
      onSelect(selected.filter((item) => item.id !== id));
      setNumSelected((prev) => prev - 1);
    }
  };

  useEffect(() => {
    const rowIds = data.map((rowData) => rowData.id);
    const filteredArray =
      selected.filter((row) => rowIds.includes(row.id)) || [];
    setNumSelected(filteredArray.length);
  }, [selected, data]);

  const HEIGHT_TATBLE_NEW_PAGINATION_NOT_EXPAND = '0px';
  const HEIGHT_TATBLE_NEW_PAGINATION_EXPAND = tableHeight;
  const HEIGHT_TATBLE_MULTILE_ITEM = '84px';

  const heightTable = useMemo(() => {
    if (useNewPagination && !isExpand) {
      return HEIGHT_TATBLE_NEW_PAGINATION_NOT_EXPAND;
    }
    if (useNewPagination && isExpand && !!data?.length) {
      return HEIGHT_TATBLE_NEW_PAGINATION_EXPAND;
    }
    if (dropTable && data?.length > 1) {
      return HEIGHT_TATBLE_MULTILE_ITEM;
    }
    return data?.length > 0 ? tableHeight : 'max-content';
  }, [data, useNewPagination, dropTable, tableHeight, isExpand]);
  const PAGE_SHOW_FLICKER_NEW_PAGINATION = 0;
  const PAGE_SHOW_FLICKER_DEFAULT = 1;

  return (
    <>
      <StyledTableScrollbar>
        <StyledTable
          height={heightTable}
          cellWidth={cellWidth}
          headerPadding={headerPadding}
          stickyHeader={isStickyHeader}
          isFlickerBg={
            !useNewPagination
              ? flickerBackground && page === PAGE_SHOW_FLICKER_DEFAULT
              : flickerBackground && page === PAGE_SHOW_FLICKER_NEW_PAGINATION
          }
          onMouseEnter={() => setShowScrollbar(true)}
          onMouseLeave={() => setShowScrollbar(false)}
          className={`sidebar-wrapper ${
            !useInfiniteScrollRequests && showScrollbar
              ? 'small-scrollbar'
              : 'hidden-scrollbar'
          } `}
        >
          <Table style={{ minWidth }} stickyHeader={isStickyHeader}>
            {useInfiniteScrollRequests ? (
              <TableBodyNew
                page={page}
                columns={columns}
                flickerBackground={flickerBackground}
                isScrolling={isScrolling}
                data={data}
                requestListHeight={requestListHeight}
                selection
                dropTable={dropTable}
                showNumber={showNumber}
                onChangePage={onChangePage}
                isSelected={isSelected}
                loading={loading}
                onSelectRow={handleSelectRow}
                onRowClick={onRowClick}
                isShowCheckbox={isShowCheckbox}
              />
            ) : (
              <CustomTableBody
                page={page}
                dropTable={dropTable}
                columns={columns}
                data={data}
                tableHeight={tableHeight}
                selection
                useNewPagination={useNewPagination}
                showNumber={showNumber}
                onChangePage={onChangePage}
                isSelected={isSelected}
                loading={loading}
                onSelectRow={handleSelectRow}
                onRowClick={onRowClick}
                isShowCheckbox={isShowCheckbox}
              />
            )}
          </Table>
        </StyledTable>
      </StyledTableScrollbar>
      {/* {!isNewHomepage && useNewPagination && isExpand && data.length > 0 && ()} */}
      {useNewPagination && isExpand && data.length > 0 && (
        <TableFooterNew
          total={total}
          page={page}
          useNewPagination={useNewPagination}
          rowsPerPage={rowsPerPage}
          onChangeRowPage={onChangeRowPage}
          onChangePage={onChangePage}
          limit={limit}
        />
      )}

      {!useInfiniteScrollRequests && !useNewPagination && data.length > 0 && (
        <CustomTableFooter
          total={total}
          page={page}
          onChangePage={onChangePage}
          footerPadding={footerPadding}
          limit={limit}
        />
      )}

      {!loading && !data?.length ? (
        <div>
          <NoData
            dropTable={dropTable}
            useNewRequestUI={useNewRequestUI}
            height={dropTable ? '131px' : '326px'}
          />
        </div>
      ) : null}
      {loading && !data?.length && <StyledFooterLoading />}
      {loading &&
        !data.length &&
        !useInfiniteScrollRequests &&
        !isScrolling &&
        dropTable && (
          <div>
            <StyledFooterLoading />
          </div>
        )}
    </>
  );
};

export default CustomTable;
